import { useState } from "react";
import "./styles.css";
import Config from "../../config/config";
import { useSearchParams } from "react-router-dom";

function AbrirChamado() {
  const [isOther, setIsOther] = useState("select");
  const [customSubject, setCustomSubject] = useState("");
  const [message, setMessage] = useState("");
  const [subjectParams] = useSearchParams();
  const assuntoDaURL = subjectParams.get("assunto");

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject =
      isOther === "Outros" ? customSubject : isOther || "Chamado Suporte";
    const email = Config.SUPPORT_EMAIL;
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="wrapper">
      <div className="chamado">
        <div className="logoAbrirChamado">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>

        <div className="formChamado">
          <span className="titleTextChamado">Abrir chamado</span>
          <form className="form" onSubmit={handleSubmit}>
            {assuntoDaURL && assuntoDaURL === "inativo" ? (
              <div className="formGroup">
                <label htmlFor="assunto">Assunto</label>
                <input
                  id="assunto"
                  className="inputForm"
                  type="text"
                  placeholder="Digite aqui"
                  value={customSubject || "Resolvendo pendências"}
                  onChange={(e) => setCustomSubject(e.target.value)}
                  required
                />
              </div>
            ) : isOther !== "Outros" ? (
              <div className="formGroup">
                <label htmlFor="assuntoSelect">Assunto</label>
                <select
                  id="assuntoSelect"
                  className="inputForm"
                  onChange={(e) => setIsOther(e.target.value)}
                >
                  <option value="Financeiro">Financeiro</option>
                  <option value="Problemas com meu link">
                    Problemas com meu link
                  </option>
                  <option value="Página com tela branca">
                    Página com tela branca
                  </option>
                  <option value="Falha na conversão do dólar">
                    Falha na conversão do dólar
                  </option>
                  <option value="Outros">Outros</option>
                </select>
              </div>
            ) : (
              <div className="formGroup">
                <label htmlFor="assunto">Assunto</label>
                <input
                  id="assunto"
                  className="inputForm"
                  type="text"
                  placeholder="Digite aqui"
                  value={customSubject}
                  onChange={(e) => setCustomSubject(e.target.value)}
                  required
                />
              </div>
            )}

            <div className="formGroup">
              <label htmlFor="txtChamado">Mensagem</label>
              <textarea
                id="txtChamado"
                className="txtChamado"
                placeholder="Digite aqui"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>

              <span style={{ fontSize: 15, color: "#c95757", paddingTop: 10 }}>
                OBS: O tempo de resposta pode ser de até 48 horas. Caso
                participe de algum grupo, entre em contato com um administrador.
              </span>
            </div>

            <button type="submit">Abrir chamado</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AbrirChamado;
